module.exports = __webpack_public_path__ + "img/idnr_logo.f21b7c0.png";